package com.islamicmedia.site.components

import androidx.compose.runtime.Composable
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun AccessDeniedScreen(
    userEmail: String?,
    onCheckAgain: () -> Unit,
    onSignOut: () -> Unit
) {
    Div(attrs = {
        style {
            width(100.percent)
            property("min-height", "100vh")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("background", GradientHeader)
            padding(24.px)
        }
    }) {
        // Logo
        Img(src = "/images/logo.png", attrs = {
            style {
                width(100.px)
                height(100.px)
                marginBottom(24.px)
            }
        })

        // Card
        Div(attrs = {
            style {
                backgroundColor(Color.white)
                borderRadius(24.px)
                property("box-shadow", CardShadow)
                padding(32.px)
                width(100.percent)
                property("max-width", "420px")
                property("text-align", "center")
            }
        }) {
            H2(attrs = {
                style {
                    fontSize(22.px)
                    fontWeight(700)
                    color(Gray900)
                    marginBottom(16.px)
                }
            }) {
                Text("Access Restricted")
            }

            P(attrs = {
                style {
                    fontSize(15.px)
                    color(Gray600)
                    property("line-height", "1.5")
                    marginBottom(12.px)
                }
            }) {
                Text("Your account is not yet approved for access. Please click the button below to join the program.")
            }

            P(attrs = {
                style {
                    fontSize(14.px)
                    color(Gray600)
                    property("line-height", "1.5")
                    marginBottom(20.px)
                }
            }) {
                Text("Please make sure you're signing into Fitrah Filter using the same email that you registered to the Good Child program with.")
            }

            // Green with gold border — matches the "founding member" button on the search page
            A(href = "https://learn.thegoodchild.org/the-fitrah-filter/", attrs = {
                attr("target", "_blank")
                style {
                    property("display", "inline-block")
                    width(100.percent)
                    property("box-sizing", "border-box")
                    padding(14.px)
                    fontSize(16.px)
                    fontWeight(600)
                    property("color", "#DAA520")
                    backgroundColor(Primary)
                    property("border", "2px solid #DAA520")
                    borderRadius(24.px)
                    property("text-decoration", "none")
                    property("text-align", "center")
                    cursor("pointer")
                    property("transition", TransitionMedium)
                    property("box-shadow", "0 4px 16px rgba(0,0,0,0.15)")
                    marginBottom(20.px)
                }
            }) {
                Text("Join the program")
            }

            if (userEmail != null) {
                P(attrs = {
                    style {
                        fontSize(13.px)
                        color(Gray400)
                        marginBottom(8.px)
                    }
                }) {
                    Text("Signed in as: $userEmail")
                }
            }

            P(attrs = {
                style {
                    fontSize(13.px)
                    color(Gray600)
                    property("line-height", "1.5")
                    marginBottom(24.px)
                }
            }) {
                Text("If you're already part of the program but can't get in, please contact ")
                Span(attrs = {
                    style {
                        color(Primary)
                        fontWeight(500)
                    }
                }) {
                    Text("support@fitrahfilter.com")
                }
            }

            Button(attrs = {
                onClick { onSignOut() }
                style {
                    width(100.percent)
                    padding(14.px)
                    fontSize(16.px)
                    fontWeight(600)
                    color(Gray700)
                    backgroundColor(Color.white)
                    borderRadius(12.px)
                    property("border", "1px solid ${Gray300}")
                    cursor("pointer")
                    property("transition", TransitionMedium)
                }
            }) {
                Text("Sign Out")
            }
        }
    }
}
